import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL } from "../../../Config";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { DownloadTableExcel } from "react-export-table-to-excel";
import moment from "moment";

function AppFeedback() {
  const token = localStorage.getItem("token");

  const emailid = localStorage.getItem("emailId");
  const [isLoader, setIsLoader] = useState(false);
  const [feedback, setFeedback] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [remark, setRemark] = useState("");
  const [message, setMessage] = useState("");
  const tableAppFeedback = React.useRef(null);

  useEffect(() => {
    getHelpline();
  }, []);
  const getHelpline = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/getfeedBack/1`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response:::::::", response);
        setIsLoader(false);
        setFeedback(response?.data);
      })
      .catch((error) => {
        setIsLoader(false);
        console.log(error);
      });
  };

  const remarkChange = (e) => {
    setMessage(e.target.value);
  };
  const handleSubmit = (remark) => {
    if (message === "") {
      toast.warning("All field required");
    } else {
      console.log("remark", remark);
      console.log("message", message);
      const data = {
        id: remark?.id,
        remarkBy: remark?.remarkBy,
        remark: message,
        ownerEmail: emailid,
      };
      axios
        .request(`${APIURL}/getfeedBackRemark`, {
          method: "POST",
          data: data,
          headers: {
            Authentication: token,

            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response:::::::", response);
          setShowModal(false);
          getHelpline();
          setIsLoader(false);
        })
        .catch((error) => {
          setIsLoader(false);
          console.log(error);
        });
    }
  };
  return (
    <div className="p-3">
      <div>
        <ul className="nav nav-tabs" id="myTabs" role="tablist">
          <li className="nav-item" role="presentation">
            <button
              className="nav-link active tab-item "
              id="profile-tab"
              data-bs-toggle="tab"
              data-bs-target="#profile"
              type="button"
              role="tab"
              aria-controls="profile"
              aria-selected="true"
            >
              App Feedback
            </button>
          </li>
        </ul>
        <div className="tab-content mt-3" id="myTabsContent">
          <div
            className="tab-pane fade show active"
            id="profile"
            role="tabpanel"
            aria-labelledby="profile-tab"
          >
            <div className="pt-3">
              <div className="card">
                <DownloadTableExcel
                  filename="AppFeedback"
                  sheet="users"
                  currentTableRef={tableAppFeedback.current}
                >
                  <button
                    className="btn btn-success mb-3 mb-md-0 mt-3 ml-3"
                    style={{
                      width: "120px",
                      backgroundColor: "#66a725",
                    }}
                  >
                    Download
                  </button>
                </DownloadTableExcel>
                <div className="p-3 pt-4">
                  {isLoader ? (
                    <div className="d-flex justify-content-center">
                      <div
                        className="spinner-border text-success"
                        role="status"
                      >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-striped">
                        <thead>
                          <tr>
                            <th style={{ textAlign: "center" }}>Sr. No</th>
                            <th style={{ textAlign: "center" }}>Entry date</th>
                            <th style={{ textAlign: "center" }}>Entry time</th>
                            <th style={{ textAlign: "center" }}>
                              Employer name/Code
                            </th>
                            <th style={{ textAlign: "center" }}>User name</th>
                            <th style={{ textAlign: "center" }}>Mobile</th>
                            <th style={{ textAlign: "center" }}>
                              Points given
                            </th>
                            <th style={{ textAlign: "center" }}>His Remark</th>
                            <th style={{ textAlign: "center" }}>
                              Our reply to his remark
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {feedback.map((item, i) => (
                            <tr>
                              <td>{i + 1}</td>
                              <td style={{ textAlign: "center" }}>
                                {new Date(item.entrydate).toLocaleDateString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  }
                                )}
                              </td>
                              <td>{item.entrytime}</td>
                              <td>{item.employerName}</td>
                              <td>{item.name}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.mobileno}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                {item?.score}
                              </td>
                              <td>{item?.comment}</td>
                              {item?.remark === "" || item?.remark === null ? (
                                <td>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      className="btn btn-success"
                                      style={{ width: "150px" }}
                                      onClick={() => {
                                        setRemark(item);
                                        setShowModal(true);
                                      }}
                                    >
                                      Reply
                                    </button>
                                  </div>
                                </td>
                              ) : (
                                <td>{item?.remark}</td>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
                      <Modal
                        show={showModal}
                        onHide={() => setShowModal(false)}
                        style={{ background: "rgb(255 255 255 / 40%)" }}
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Remark</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <input
                            type="text"
                            value={message}
                            onChange={remarkChange}
                            style={{
                              width: "100%",
                              padding: "10px",
                              boxSizing: "border-box",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              marginTop: "10px",
                              fontSize: "18px",
                            }}
                          />
                          <div className="d-flex mt-3 justify-content-end">
                            <button
                              className="btn btn-secondary"
                              style={{ width: "100px" }}
                              onClick={() => setShowModal(false)}
                            >
                              Cancel
                            </button>
                            <button
                              className="btn btn-success ml-2"
                              style={{
                                width: "100px",
                                background: "#66a725",
                              }}
                              onClick={() => handleSubmit(remark)}
                            >
                              Submit
                            </button>
                          </div>
                        </Modal.Body>
                      </Modal>
                    </div>
                  )}
                  <table
                    className="table table-striped mt-3 "
                    style={{ display: "none" }}
                    ref={tableAppFeedback}
                  >
                    <thead>
                      <tr>
                        <th style={{ textAlign: "center" }}>Sr. No</th>
                        <th style={{ textAlign: "center" }}>Entry date</th>
                        <th style={{ textAlign: "center" }}>Entry time</th>
                        <th style={{ textAlign: "center" }}>
                          Employer name/Code
                        </th>
                        <th style={{ textAlign: "center" }}>User name</th>
                        <th style={{ textAlign: "center" }}>Mobile</th>
                        <th style={{ textAlign: "center" }}>Points given</th>
                        <th style={{ textAlign: "center" }}>His Remark</th>
                        <th style={{ textAlign: "center" }}>
                          Our reply to his remark
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {feedback.map((item, i) => (
                        <tr>
                          <td>{i + 1}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.entrydate}
                          </td>
                          <td>{item.entrytime}</td>
                          <td>{item.employerName}</td>
                          <td>{item.name}</td>
                          <td style={{ textAlign: "center" }}>
                            {item.mobileno}
                          </td>
                          <td style={{ textAlign: "center" }}>{item?.score}</td>
                          <td>{item?.comment}</td>
                          {item?.remark === "" || item?.remark === null ? (
                            <td>
                              <div className="d-flex justify-content-center">
                                <button
                                  className="btn btn-success"
                                  style={{ width: "150px" }}
                                  onClick={() => {
                                    setRemark(item);
                                    setShowModal(true);
                                  }}
                                >
                                  Reply
                                </button>
                              </div>
                            </td>
                          ) : (
                            <td>{item?.remark}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppFeedback;
